<template>
  <MissionContainer :header-url="mission.module.config.media_url + mission.module_id + '/thumbnail'">
    <h1 style="margin-bottom: 30px">{{mission.module.config.label}}</h1>

    <p class="ContextBlockSpec">
      Vous avez choisi le défi "être plus actif". Avant de commencer, il est important d'évaluer vos capacités physiques afin de mieux adapter votre effort.
    </p>

    <p class="ObjectiveBlockSpec">
      <b class="primary--text">Objectif : </b>
      Évaluer ses capacités physiques.
    </p>

    <div class="InstructionsBlockSpec">
      Pour réaliser cette mission, vous devez :<br/>
      <ol>
        <li>Répondre au questionnaire</li>
        <li>VALIDER la mission</li>
      </ol>
    </div>


    <!-- ///TODO Vidéo d'introduction Evaluation physique par Kader -->

    <div style="background: #F8F8F8; border-radius: 12px; padding: 55px 25px; margin-bottom: 30px;" class="mt-5">
      <div v-show="ui.step === 'acceuil'">

        <p style="font-size: 18px" class="primary--text">Attention, si vous présentez une maladie chronique, consultez votre médecin traitant avant de reprendre ou
          d’intensifier votre activité physique. En remplissant ce questionnaire, vous vous engagez à dire la vérité sur
          votre état de santé et assumez par conséquent toutes les responsabilités en cas de mensonge.</p>

        <p style="text-align: center">Commencer le questionnaire : « Évaluez vos capacités physiques »</p>

        <p style="font-style: italic;" class="primary--text">En remplissant ce questionnaire, vous engagez votre responsabilité quant à la véracité des informations renseignées</p>

        <v-btn block
               large
               rounded
               @click="step('q1')"
               class="primary mt-10 mb-4">Allons-y !
        </v-btn>
      </div>

      <div v-show="ui.step === 'q1'">
      <h3 class="Category">
        Symptômes cardiaques
      </h3>
        <br/>
        <br/>
        <p class="Question">
          Lors d’une activité physique, ressentez-vous des douleurs à la poitrine, des palpitations (vous sentez
          désagréablement les battements de votre cœur qui peuvent aussi être irréguliers) ou faites-vous des malaises ?
        </p>

        <v-radio-group v-model="missionData.quiz.question1">
          <v-radio :value="0" label="Oui"></v-radio>
          <v-radio :value="1" label="Non"></v-radio>
        </v-radio-group>

        <v-btn block
               large
               rounded
               :disabled="missionData.quiz.question1 === null"
               @click="step('q2')"
               class="primary mt-10 mb-4">Suite
        </v-btn>
      </div>

      <div v-show="ui.step === 'q2'">
      <h3 class="Category">
        Douleur durant l’effort
      </h3>
        <br/>
        <br/>
        <p class="Question">
          Avez-vous des douleurs articulaires pour des activités de la vie quotidienne comme jardiner, vous déplacer à
          pied, monter un étage, faire du vélo…
        </p>

        <v-radio-group v-model="missionData.quiz.question2">
          <v-radio :value="0" label="Oui"></v-radio>
          <v-radio :value="1" label="Non"></v-radio>
        </v-radio-group>

        <v-btn block
               large
               rounded
               :disabled="missionData.quiz.question2 === null"
               @click="step(missionData.quiz.question2 === 0 ? 'q3' : 'q5')"
               class="primary mt-10 mb-4">Suite
        </v-btn>
      </div>

      <div v-show="ui.step === 'q3'">
      <h3 class="Category">
        Douleur durant l’effort
      </h3>
        <br/>
        <br/>
        <p class="Question">
          A combien mesurez-vous la douleur articulaire sur cette échelle de 0 à 10 ?
        </p>

        <IriadeEVAInputFormBlock :input="{ config: { default: 0, range: [0, 10] }, label: '' }" :input-index="0"
                                 v-model="missionData.quiz.question3"></IriadeEVAInputFormBlock>

        <v-btn block
               large
               rounded
               :disabled="missionData.quiz.question3 === null"
               @click="step('q4')"
               class="primary mt-10 mb-4">Suite
        </v-btn>
      </div>

      <div v-show="ui.step === 'q4'">
      <h3 class="Category">
        Douleur durant l’effort
      </h3>
        <br/>
        <br/>
        <p class="Question">
          Pouvez-vous localiser la douleur ?
        </p>

        <v-text-field v-model="missionData.quiz.question4" outlined></v-text-field>

        <v-btn block
               large
               rounded
               :disabled="missionData.quiz.question4 === null"
               @click="step('q5')"
               class="primary mt-10 mb-4">Suite
        </v-btn>
      </div>

      <div v-show="ui.step === 'q5'">
      <h3 class="Category">
        Essoufflement
      </h3>
        <br/>
        <br/>
        <p class="Question">
          Pour des activités de la vie quotidienne comme jardiner, vous déplacer à pied, monter un étage, faire du
          vélo… , à combien mesurez-vous votre essoufflement ?
        </p>

        <IriadeEVAInputFormBlock
          :input="{ config: { default: 0, range: [0, 10] }, label: labelsQ5[missionData.quiz.question5] }"
          :input-index="1" v-model="missionData.quiz.question5"></IriadeEVAInputFormBlock>

        <v-btn block
               large
               rounded
               :disabled="missionData.quiz.question5 === null"
               @click="step('q6')"
               class="primary mt-10 mb-4">Suite
        </v-btn>
      </div>

      <div v-show="ui.step === 'q6'">
      <h3 class="Category">
        Faiblesse musculaire
      </h3>
        <br/>
        <br/>
        <p class="Question">
          A combien évaluez-vous la difficulté pour des activités de la vie quotidienne comme jardiner, vous déplacer à
          pied, monter un étage, faire du vélo…  sur une échelle de 0 à 10 ?
        </p>

        <IriadeEVAInputFormBlock
          :input="{ config: { default: 0, range: [0, 10] }, label: labelsQ6[missionData.quiz.question6] }"
          :input-index="1" v-model="missionData.quiz.question6"></IriadeEVAInputFormBlock>

        <v-btn block
               large
               rounded
               :disabled="missionData.quiz.question6 === null"
               @click="step('q7')"
               class="primary mt-10 mb-4">Suite
        </v-btn>
      </div>

      <div v-show="ui.step === 'q7'">
      <h3 class="Category">
        Connaissance activité physique
      </h3>
        <br/>
        <br/>
        <p class="Question">
          L’activité physique et le sport, est-ce différent ?
        </p>

        <v-radio-group v-model="missionData.quiz.question7">
          <v-radio :value="0" label="Oui, c’est différent"></v-radio>
          <v-radio :value="1" label="Non, c’est similaire"></v-radio>
        </v-radio-group>

        <v-btn block
               large
               rounded
               :disabled="missionData.quiz.question7 === null"
               @click="step('q8')"
               class="primary mt-10 mb-4">Suite
        </v-btn>
      </div>

      <div v-show="ui.step === 'q8'">
      <h3 class="Category">
        Connaissance activité physique
      </h3>
        <br/>
        <br/>
        <p class="Question">
          Avez-vous déjà pratiqué une activité physique ?
        </p>

        <v-radio-group v-model="missionData.quiz.question8">
          <v-radio :value="0" label="Oui"></v-radio>
          <v-radio :value="1" label="Non, jamais"></v-radio>
        </v-radio-group>

        <v-btn block
               large
               rounded
               :disabled="missionData.quiz.question8 === null"
               @click="step('q9')"
               class="primary mt-10 mb-4">Suite
        </v-btn>
      </div>

      <div v-show="ui.step === 'q9'">
      <h3 class="Category">
        Connaissance activité physique
      </h3>
        <br/>
        <br/>
        <p class="Question">
          Faites-vous au moins 30 min de marche par jour ?
        </p>

        <v-radio-group v-model="missionData.quiz.question9">
          <v-radio :value="0" label="Oui"></v-radio>
          <v-radio :value="1" label="Non"></v-radio>
        </v-radio-group>

        <v-btn block
               large
               rounded
               :disabled="missionData.quiz.question9 === null"
               @click="step('q10')"
               class="primary mt-10 mb-4">Résultats
        </v-btn>
      </div>

      <div v-show="ui.step === 'q10'">
      <h3 class="Category">
        Mesurer la motivation
      </h3>
        <br/>
        <br/>
        <p class="Question">
          Avez-vous réellement envie de pratiquer une activité physique ?
        </p>

        <v-radio-group v-model="missionData.quiz.question10">
          <v-radio :value="0" label="Oui"></v-radio>
          <v-radio :value="1" label="Non"></v-radio>
        </v-radio-group>

        <v-btn block
               large
               rounded
               :disabled="missionData.quiz.question10 === null"
               @click="step('q11')"
               class="primary mt-10 mb-4">Résultats
        </v-btn>
      </div>

      <div v-show="ui.step === 'q11'">
      <h3 class="Category">
        Mesure de la capacité d’organisation
      </h3>
        <br/>
        <br/>
        <p class="Question">
          Arrivez-vous à vous organiser pour consacrer un moment pour pratiquer une activité physique ?
        </p>

        <v-radio-group v-model="missionData.quiz.question11">
          <v-radio :value="0" label="Oui"></v-radio>
          <v-radio :value="1" label="Non"></v-radio>
        </v-radio-group>

        <v-btn block
               large
               rounded
               :disabled="missionData.quiz.question11 === null"
               @click="step('q12')"
               class="primary mt-10 mb-4">Résultats
        </v-btn>
      </div>

      <div v-show="ui.step === 'q12'">
      <h3 class="Category">
        Mesure de l'autodiscipline
      </h3>
        <br/>
        <br/>
        <p class="Question">
          Quand vous vous persuadez qu’il faut pratiquer une activité physique, arrivez-vous à mettre en pratique
          cette envie ?
        </p>

        <v-radio-group v-model="missionData.quiz.question12">
          <v-radio :value="0" label="Oui"></v-radio>
          <v-radio :value="1" label="Non"></v-radio>
        </v-radio-group>

        <v-btn block
               large
               rounded
               :disabled="missionData.quiz.question12 === null"
               @click="step('resultats')"
               class="primary mt-10 mb-4">Résultats
        </v-btn>
      </div>

      <div v-show="ui.step === 'resultats'">
        <h3 class="mb-5">Pour terminer ce questionnaire voici la liste de nos conseils en fonction de votre état de santé. Il est très important de lire et d'appliquer ces conseils avant de continuer votre défi « Être plus actif ».</h3>

        <div class="Info" v-if="missionData.quiz.question1 === 0 || (missionData.quiz.question2 === 0 && missionData.quiz.question3 >= 5) || missionData.quiz.question5 >= 5 || missionData.quiz.question6 >= 5">
          <v-icon class="primary--text mr-1">warning</v-icon>Les résultats du questionnaire santé mettent en évidence des symptômes et difficultés qui nécessitent de prendre l’avis de votre médecin traitant avant de commencer le défi. En effet, il faut s’assurer que votre état de santé vous permet de commencer une activité physique ou de l’augmenter. Une fois l’accord de votre médecin traitant obtenu, vous pourrez débuter votre défi !
          <div>
            Symptômes en cause :
            <ul>
              <li v-if="missionData.quiz.question1 === 0">Symptômes cardiaques</li>
              <li v-if="missionData.quiz.question2 === 0 && missionData.quiz.question3 >= 5">Douleurs articulaires durant l’effort</li>
              <li v-if="missionData.quiz.question5 >= 5">Essoufflement</li>
              <li v-if="missionData.quiz.question6 >= 5">Faiblesse musculaire</li>
            </ul>
          </div>
        </div>

        <div class="Info" v-if="scoreConnaissanceAP >= 2">
          <li>Vous avez besoin de conseil pour démarrer</li>
          <p>Les résultats du questionnaire montrent que vous souhaitez débuter ou reprendre une activité physique et vous avez besoin de conseils concrets pour bien démarrer. Vous trouvez, dans la vidéo et la fiche pdf associée, les conseils de votre coach Kader pour vous lancer, en sécurité, dans votre défi !</p>
          <IriadeApplicationMediaBlock :block="{ config: mission.module.config.media_reprise }"></IriadeApplicationMediaBlock>
        </div>

        <div class="Info" v-if="scoreMotivation >= 2">
          <h3>Vous manquez de motivation</h3>
          <p>Les résultats du questionnaire montrent que vous manquez de motivation pour pratiquer durablement une activité physique. Dans cette vidéo, Kader, votre coach, vous propose des solutions concrètes pour vous aider à pratiquer sans difficultés et ainsi gagner en confiance et motivation. Vous trouverez des conseils complémentaires dans la fiche pdf associée. A vous de jouer !</p>
          <IriadeApplicationMediaBlock :block="{ config: mission.module.config.media_motivation }"></IriadeApplicationMediaBlock>
        </div>

        <div class="Info" v-if="(missionData.quiz.question2 === 0 && missionData.quiz.question3 >= 3) || missionData.quiz.question5 >= 3 || missionData.quiz.question6 >= 3">
          <h3>Vous avez une gêne physique</h3>
          <p>Les résultats du questionnaire montrent qu’il peut être difficile, pour vous, de faire une activité physique car vous ressentez des douleurs, un essoufflement ou bien une faiblesse musculaire pendant la pratique. Vous trouverez dans la vidéo et la fiche pdf associée les conseils de votre coach Kader pour pratiquer en sécurité et adapter votre activité à votre condition physique. Allez, c’est parti !</p>
          <IriadeApplicationMediaBlock :block="{ config: mission.module.config.media_autre }"></IriadeApplicationMediaBlock>
        </div>

        <v-btn block
               large
               rounded
               @click="step('fin')"
               class="primary mt-10 mb-4">Fin
        </v-btn>
      </div>

      <div v-show="ui.step === 'fin'">
        <div class="Info">
          Merci d'avoir répondu à ce questionnaire.<br/>
          Vous pourrez retrouver l'analyse de vos réponses dans votre Profil Salutance.<br/>
          <p class="my-4">
            Une fois que vous avez vu votre médecin, vous pourrez reprendre votre défi et vous appuyer sur les conseils transmis dans les vidéos. Vous pouvez à tout moment revoir ces vidéos dans votre Médiathèque.
          </p>
        </div>


        <p class="primary--text" style="font-size: 15px; font-style: italic">Appuyer sur « Valider la mission » pour
          valider et enregistrer ce questionnaire</p>

        <FinishMissionButtonBlock class="mt-10"
                                  @click.native="finishMission">Valider la mission
        </FinishMissionButtonBlock>
      </div>
    </div>
  </MissionContainer>
</template>

<script>
  import api from 'api'
  import FinishMissionButtonBlock from 'components/blocks/FinishMissionButtonBlock'
  import MissionContainer from 'components/blocks/MissionContainer'
  import IriadeEVAInputFormBlock from "../../../../../../Iriade/Blocks/IriadeFormBlock/Inputs/IriadeEVAInputFormBlock";
  import IriadeApplicationMediaBlock from "../../../../../../Iriade/Blocks/IriadeApplicationMediaBlock/IriadeApplicationMediaBlock";

  export default {
    components: {
      IriadeApplicationMediaBlock,
      IriadeEVAInputFormBlock,
      FinishMissionButtonBlock,
      MissionContainer
    },
    data () {
      return {
        missionData: {
          quiz: {
            question1: null,
            question2: null,
            question3: null,
            question4: null,
            question5: null,
            question6: null,
            question7: null,
            question8: null,
            question9: null,
            question10: null,
            question11: null,
            question12: null,
          },
          analyse: {
            douleurs_articulaires: false,
            essoufflement: false,
            faiblesse_musculaire: false,
            connaissance_ap: false,
            motivation: false,
            medecin: false,
          }
        },
        labelsQ5: [
          'Rien du tout',
          'Très léger essoufflement',
          'Légère',
          'Modérée',
          'Un peu sévère',
          'Sévère',
          'Plus sévère',
          'Très sévère',
          'Très sévère',
          'Très, très sévère',
          'Maximal',
        ],
        labelsQ6: [
          'Aucun effort',
          'Très très facile',
          'Très facile',
          'Facile',
          'Effort modérée',
          'Moyen',
          'Un peu difficile',
          'Difficile',
          'Très difficile',
          'Très, très difficile',
          'Maximal',
        ],
        ui: {
          step: 'acceuil'
        }
      }
    },

    computed: {
      scoreConnaissanceAP() {
        return this.missionData.quiz.question7 + this.missionData.quiz.question8 + this.missionData.quiz.question9;
      },

      scoreMotivation() {
        return this.missionData.quiz.question10 + this.missionData.quiz.question11 + this.missionData.quiz.question12;
      },
    },

    methods: {
      finishMission () {
        this.missionData.analyse.douleurs_articulaires = this.missionData.quiz.question2 === 0 && this.missionData.quiz.question3 >= 3;
        this.missionData.analyse.essoufflement = this.missionData.quiz.question5 >= 3;
        this.missionData.analyse.faiblesse_musculaire = this.missionData.quiz.question6 >= 3;
        this.missionData.analyse.connaissance_ap = this.scoreConnaissanceAP >= 2;
        this.missionData.analyse.motivation = this.scoreMotivation >= 2;
        this.missionData.analyse.medecin = this.missionData.quiz.question1 === 0 || (this.missionData.quiz.question2 === 0 && this.missionData.quiz.question3 >= 5) || this.missionData.quiz.question5 >= 5 || this.missionData.quiz.question6 >= 5;

        this.ui.loading = true
        this.errors = {}

        api.post(`missions/${this.mission.id}`, this.missionData)
          .then(res => {
            this.$mango.snackbar({
              color: 'success',
              text: "Mission validée. Bravo !"
            })
            this.$router.push({name: 'patient@dashboard'})
          })
          .catch(err => {
            this.$mango.snackbar({
              color: 'error',
              text: "Erreur de validation. Veuillez vérifier le formulaire."
            })
          })
          .then(() => {
            this.ui.loading = false
          })
      },

      step (target) {
        this.ui.step = target;
      }
    },

    props: {
      mission: {
        required: true,
        type: Object
      }
    }
  }
</script>

<style lang="scss"
       type="text/scss">
  .Category {
    font-size: 22px;
    font-weight: 500;
    text-align: center;
  }
  .Question {
    font-size: 19px;
    font-weight: 500;
    text-align: justify;
  }
  .Info {
    background-color: #c0c0c0;
    font-size: 19px;
    padding: 15px;
    margin-bottom: 20px;
    border-radius: 10px
  }
  .ContextBlockSpec {
    font-size: 18px;
    font-weight: 700;
  }
  .ObjectiveBlockSpec {
    font-size: 18px;
    font-weight: 500;
  }
  .Category {
    margin-top: 25px;
  }
  .v-label {
    font-size: 20px

  }
</style>
